import React from "react";

const FilterOption = props => {
  const { name, onClick, hide, icon, children } = props;

  const hideItem = hide
    ? "filter__item--hide"
    : "";

  return (
    <li className={`filter__item ${hideItem}`} onClick={onClick}>
      <label className="filter__label">
        <input type="radio" name={name} hidden />

        <div className="filter__badge">
          <div className="filter__icon">
            {icon}
          </div>
          <span className="filter__text">
            {children}
          </span>
        </div>
      </label>
    </li>
  );
}

export default FilterOption;